import { render } from "./MinMaxItemsChecked.vue?vue&type=template&id=27aef24e"
import script from "./MinMaxItemsChecked.vue?vue&type=script&lang=js"
export * from "./MinMaxItemsChecked.vue?vue&type=script&lang=js"
script.render = render

export default script